import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-check-box-freeform-functional',
    templateUrl: './check-box-freeform-functional.component.html',
    styleUrls: ['./check-box-freeform-functional.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckboxFreeformFunctionalComponent {
  @Input() checkMethod: () => boolean;
  @Input() helpText: string;
  @Input() caption: string;
  @Input() initialValue: boolean = false;
  @Input() isReadonly: boolean = false;

  @Output() checkboxChange: EventEmitter<boolean> = new EventEmitter();

  onCheckboxChange(event: any, checkbox: MatCheckbox): void {
    checkbox.checked = this.checkMethod();
  }
}
